import { ReactElement } from 'react';
import Modal from '../../../../components-ui/spark/Modal';
interface Props {isOpen:boolean;onClose:()=>void;onOk?:()=>void;children:ReactElement;title?:string;okText?:string;cancelText?:string;showActions?:boolean;showCloseIcon?:boolean;fullWidth?:boolean;maxWidth?:'xs'|'sm'|'md'|'lg'|'xl';}
export default function MuiModal({isOpen,onClose,children,title,showCloseIcon=true,maxWidth='md'}:Props) {
    return <Modal open={isOpen} onClose={onClose} title={title} hideClose={!showCloseIcon}
        size={maxWidth === 'xl' || maxWidth === 'lg' ? 'xl' : maxWidth === 'md' ? 'lg' : maxWidth === 'xs' ? 'sm' : undefined}>
        <div className="app-form-card">{children}</div>
    </Modal>;
}
